import { render, staticRenderFns } from "./ModalRating.vue?vue&type=template&id=66c4ea27&"
import script from "./ModalRating.vue?vue&type=script&lang=js&"
export * from "./ModalRating.vue?vue&type=script&lang=js&"
import style0 from "./ModalRating.vue?vue&type=style&index=0&id=66c4ea27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports